import { List, ListItem, ListItemText, Stack } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CurrencySelector from './Form/CurrencySelector';
import { CONFIG } from '~/config';

function UserActions() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const handleContactClicked = () => {
    window.open(`${CONFIG.app.helpCenterLink}/ask-for-help/`, '_blank');
  };

  const contactUs = (
    <List sx={{ width: 'auto', padding: 0, bgcolor: 'transparent' }}>
      <ListItem disableGutters sx={{ padding: 0, cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }} onClick={handleContactClicked}>
        <HelpIcon sx={{ mr: 0, color: theme.palette.text.primary, fontSize: 20 }} />
        <ListItemText
          sx={{ margin: 0 }}
          primary={isMobile ? 'Help?' : 'Need help?'}
          primaryTypographyProps={{ sx: { color: theme.palette.text.primary, fontSize: 14 } }}
        />
      </ListItem>
    </List>
  );

  const currencySelector = <CurrencySelector />;

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {currencySelector}
      {contactUs}
    </Stack>
  );
}

export default UserActions;
